import z from 'zod';

export const accountSchema = z.object({
  sub: z.string(),
  name: z.string(),
  given_name: z.string(),
  family_name: z.string(),
  preferred_username: z.string(),
  email: z.string(),
  email_verified: z.boolean(),
  profile: z.string(),
  picture: z.string(),
  locale: z.string(),
  updated_at: z.number(),
});
